import { theme, Typography } from "antd";

const videoUrl =
  "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-1080p.mp4";
const videoPoster =
  "https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg";

function SectionOne() {
  const { token } = theme.useToken();
  return (
    <section className="mx-auto max-w-[1920px] px-16 py-16">
      {/* Title */}
      <Typography.Title
        level={2}
        className="mb-2 text-4xl tracking-tight"
        style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
      >
        Introduction
      </Typography.Title>

      {/* Description */}
      <div className="mb-12 max-w-6xl text-lg leading-relaxed">
        <Typography.Paragraph
          className="text-left text-lg leading-relaxed tracking-wide"
          style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
        >
          Actions Page Overview
        </Typography.Paragraph>

        <Typography.Paragraph
          className="text-justify text-lg leading-relaxed tracking-wide"
          style={{ color: token.colorPrimary, fontFamily: token.fontFamily }}
        >
          The Actions Page serves as the central hub for managing interactive
          elements of the well-being platform. It allows administrators to
          create and manage rewards, events, surveys, programs and psychometric
          assessments (e.g., OCEAN IV). Each function comes with an intuitive
          workflow, ensuring that actions can be initiated, tracked, and
          reported seamlessly.
        </Typography.Paragraph>
      </div>

      {/* Video Container */}
      <div className="mx-auto aspect-video w-full max-w-6xl overflow-hidden rounded-lg bg-gray-100">
        <video
          controls
          preload="auto"
          className="h-full w-full object-cover"
          poster={videoPoster} // we can take screenshot of the video and use it as poster
        >
          <source src={videoUrl} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </section>
  );
}

export default SectionOne;
